import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=ffe80a46&scoped=true&"
import script from "./VideoPlay.vue?vue&type=script&lang=js&"
export * from "./VideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=ffe80a46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe80a46",
  null
  
)

export default component.exports